module.exports = (__webpack_require__(7079))("./src/core.js");